import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m5.65 4.376-4.1-4.1a.875.875 0 0 0-1.274 0 .875.875 0 0 0 0 1.275l4.75 4.75a.86.86 0 0 0 .625.275.86.86 0 0 0 .625-.275l4.75-4.75A.86.86 0 0 0 11.3.926.86.86 0 0 0 11.026.3.875.875 0 0 0 9.75.3z"
    }, null, -1)
  ]))]))
}
export default { render: render }